<div
  class="fixed left-0 lg:left-auto right-0 top-0 bottom-0 w-full h-full flex flex-col justify-center lg:grid lg:grid-cols-2"
>
  <div class="hidden p-8 lg:block lg:col-span-1"></div>

  <div class="p-4 lg:p-8 bg-white w-full h-full">
    <div
      class="mb-8 w-full h-full flex flex-col mt-auto max-sm:overflow-x-hidden"
    >
      @if(isCartEmpty){
      <div class="mb-8 w-full h-full flex flex-col mt-auto gap-20">
        <div
          class="flex justify-between items-center mb-8 w-full overflow-y-scroll max-h-screen"
        >
          <h1 class="font-light text-[28px]" i18n>Your Cart</h1>
        </div>
      </div>
      <!-- Vue alternative lorsque la liste est vide -->
      <div class="w-full h-full">
        <div class="text-center flex justify-center items-center">
          <h1 class="text-[24px] font-light">Your cart is empty</h1>

          <!-- Vous pouvez ajouter des liens ou des boutons ici pour encourager l'utilisateur à ajouter des produits -->
        </div>
      </div>
      <div class="w-full h-[56px] gap-10">
        <button
          ui-portal-button
          [style]="'teal'"
          [isFull]="true"
          (click)="closeModal()"
          class="flex gap-x-2 transition duration-300 hover:bg-teal-700"
        >
          Continue shopping
        </button>
      </div>
      }@else{
      <div
        class="flex justify-between items-center mb-8 w-full overflow-y-scroll max-h-screen"
      >
        <h1 class="font-light text-[28px]" i18n>Your Cart</h1>
        <button
          class="text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out bg-gray-200 rounded-full p-2 outline-none"
          (click)="closeModal()"
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="h-full flex flex-col justify-between">
        <div class="relative w-full h-full mt-auto">
          <div
            class="max-h-[80%] scrollable-list overflow-y-scroll lg:p-4 p-0 lg:gap-x-8 gap-x-2"
          >
            <div class="flow-root">
              @for (item of cart.cartItems; track item.name) {
              <ul
                role="list"
                class="divide-y divide-gray-200 dark:divide-neutral-95"
              >
                <li
                  class="py-1 sm:py-2 flex w-full sm:h-[140px] h-[184px] max-sm:overflow-hidden"
                >
                  <div class="flex ml-1 lg:ml-4">
                    <div
                      class="flex-shrink-0 sm:w-[88px] sm:h-[80px] w-[60px] h-[60px]"
                    >
                      <img
                        class="w-full h-full rounded-xl object-cover object-center"
                        [src]="[
                          'assets/images/products/' + item.product.code + '.jpg'
                            | placeholder
                        ]"
                        alt="Product image"
                      />
                    </div>
                  </div>
                  <div class="flex justify-between w-full ml-2 lg:ml-9">
                    <div class="flex flex-col">
                      <p
                        class="text-[18px] sm:text-[16px] font-medium text-gray-900 truncate"
                      >
                        {{ item.product.name }}
                      </p>
                      <p class="text-[16px] font-normal text-gray-900 truncate">
                        {{ item.product.currentPrice.amount | currency }}
                      </p>
                      <div
                        class="flex items-center lg:gap-x-5 gap-x-1 gap-y-3 flex-wrap"
                      >
                        <h1
                          class="text-[16px] lg:text-[14px] font-normal text-gray-900 truncate"
                        >
                          Size: {{ item.priceUnit }}
                        </h1>
                        <div
                          class="flex lg:gap-x-5 gap-x-1 justify-center items-center"
                        >
                          <ui-counter
                            [style]="'basket'"
                            (quantityEmitter)="
                              getCounterNumber(item.product, $event)
                            "
                            >{{ quantity }}
                          </ui-counter>
                          <button (click)="handleRemoveItem(item.product)">
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.1668 24.5002H12.7547C9.54539 24.5002 7.94073 24.5002 6.82703 23.6137C5.30911 22.3934 5.20511 19.9181 4.90094 18.1859L4.20958 14.2491C4.08556 13.5429 3.61302 12.9357 2.93831 12.6156C2.77562 12.5383 2.65961 12.3942 2.62393 12.225C2.42536 11.2827 1.89763 9.97155 3.07797 9.45114C3.34481 9.3335 3.70926 9.3335 4.43813 9.3335H8.75017M13.4168 9.3335H23.5622C24.2911 9.3335 24.6556 9.3335 24.9224 9.45114C26.1027 9.97155 25.575 11.2827 25.3764 12.225C25.3407 12.3942 25.2247 12.5383 25.062 12.6156C24.1992 13.0251 23.912 13.7584 23.7381 14.5835"
                                stroke="#FF3B30"
                                stroke-width="1.3"
                                stroke-linecap="round"
                              />
                              <path
                                d="M18.6665 17.5L22.1665 21M22.1665 21L25.6665 24.5M22.1665 21L18.6665 24.5M22.1665 21L25.6665 17.5"
                                stroke="#FF3B30"
                                stroke-width="1.3"
                                stroke-linecap="round"
                              />
                              <path
                                d="M7.5835 12.8333L11.6668 3.5M17.5002 3.5L20.4168 9.33333"
                                stroke="#FF3B30"
                                stroke-width="1.3"
                                stroke-linecap="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="text-gray-900 w-full flex justify-end lg:min-w-[94px] min-w-[80px] text-nowrap"
                  >
                    <p class="font-semibold text-[16px] lg:text-[18px]">
                      {{
                        getTotalForItem(
                          item?.quantity,
                          item?.product?.currentPrice?.amount
                        ) | currency
                      }}
                    </p>
                  </div>
                </li>
              </ul>
              }
            </div>
          </div>
        </div>

        <div class="w-full h-[32px] flex justify-between mb-8">
          <h1 class="font-normal text-[24px]" i18n>
            Total items(
            <a>{{ cart.totalItems }}</a>
            )
          </h1>

          <h1 class="font-normal text-[24px]" i18n>
            {{ cart.totalAmount | currency }}
          </h1>
        </div>
        <div class="justify-center items-center w-full h-[52px] gap-8">
          <button
            ui-portal-button
            [style]="'teal'"
            [isFull]="true"
            class="flex gap-x-2 transition duration-300 hover:bg-teal-700"
            (click)="handleSaveCart()"
          >
            Order <ng-icon name="heroArrowRight" size="24px"></ng-icon>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>
